exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.permanent-alert[data-v-24b959d3] {\n    display: block !important;\n    opacity: 1 !important;\n    transition: none !important;\n}\n", ""]);

// exports
